const state = () => ({
  language:null,
  languages:[],
  activelang:null,
  lang_phrases:[],
});
const getters = {
  language(state){
    return state.language
  },
  languages(state){
    return state.languages
  },
  activelang(state){
    return state.activelang
  },
  lang_phrases(state){
    return state.lang_phrases
  },
};
const  mutations =  {
  SET_LANGUAGE(state,data){
    state.language = data
  },
  SET_LANGUAGES(state,data){
    state.languages = data
  },
  SET_ACTIVE_LANG(state,data){
    state.activelang = data
  },
  SET_LANG_PHRASES(state,data){
    state.lang_phrases = data
  },
};
const actions =  {
  setLanguage({commit},data)  {
    commit("SET_LANGUAGE",data)
  },
  setLanguages({commit},data)  {
    commit("SET_LANGUAGES",data)
  },
  setactivelang({commit},data)  {
    commit("SET_ACTIVE_LANG",data)
  },
  setLangPhrases({commit},data)  {
    commit("SET_LANG_PHRASES",data)
  },
}

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};

